import { useManifestViewsV2 } from "hooks/useManifestViewsV2";

import { Manifests } from "./Manifests";
import { Manifests as ManifestsV1 } from "./ManifestsV1";

/**
 * Routes the Manifests page to the v2 view when manifest-views-v2 is enabled
 * for the tenant (or the user is staff), and to the v1 view otherwise.
 */
export function ManifestsView() {
  const showManifestViewsV2 = useManifestViewsV2();
  return showManifestViewsV2 ? <Manifests /> : <ManifestsV1 />;
}
